var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAsset9(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_036-ambulance",
    "data-name": "036-ambulance",
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.985,
    height: 57.038,
    viewBox: "0 0 65.985 57.038",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17250",
    "data-name": "Path 17250",
    d: "M65.7,116.637,62.87,113.08a1.288,1.288,0,0,0-1.008-.486h-.994l-9.582-12.035a1.289,1.289,0,0,0-1.008-.486H47.331V97.14A4.443,4.443,0,0,0,42.9,92.7H30.31v-.587a6.644,6.644,0,0,0-13.288,0V92.7H4.433A4.444,4.444,0,0,0,0,97.14v32.378a1.289,1.289,0,0,0,1.289,1.289H4.16a6.416,6.416,0,0,0,12.582,0H49.009a6.416,6.416,0,0,0,12.582,0H64.7a1.289,1.289,0,0,0,1.289-1.289V117.44A1.289,1.289,0,0,0,65.7,116.637ZM49.656,102.651l7.917,9.943H47.331v-9.943ZM19.6,92.109a4.067,4.067,0,0,1,8.133,0V92.7H19.6v-.587ZM2.578,97.14a1.863,1.863,0,0,1,1.855-1.867H42.9a1.863,1.863,0,0,1,1.855,1.867v31.089H16.742a6.416,6.416,0,0,0-12.582,0H2.578Zm7.874,36.244a3.866,3.866,0,1,1,3.842-3.866A3.859,3.859,0,0,1,10.451,133.384Zm44.849,0a3.866,3.866,0,1,1,3.843-3.866A3.859,3.859,0,0,1,55.3,133.384Zm8.107-5.155H61.591a6.416,6.416,0,0,0-12.582,0H47.331V115.172h13.91l2.166,2.719Z",
    transform: "translate(0 -78.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17251",
    "data-name": "Path 17251",
    d: "M174.918,38.841a1.289,1.289,0,0,0,1.289-1.289v-1.56a1.289,1.289,0,0,0-2.578,0v1.56A1.289,1.289,0,0,0,174.918,38.841Z",
    transform: "translate(-151.252 -34.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17252",
    "data-name": "Path 17252",
    d: "M234.04,70.148a1.289,1.289,0,0,0,1.822-.05l1.369-1.447a1.289,1.289,0,1,0-1.872-1.771l-1.37,1.447A1.289,1.289,0,0,0,234.04,70.148Z",
    transform: "translate(-203.526 -62.381)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17253",
    "data-name": "Path 17253",
    d: "M104.717,70.1a1.289,1.289,0,0,0,1.872-1.772l-1.37-1.447a1.289,1.289,0,0,0-1.872,1.772Z",
    transform: "translate(-89.721 -62.381)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "translate(11.714 23.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17254",
    "data-name": "Path 17254",
    d: "M90.9,216.592h23.761v14.6H90.9Z",
    transform: "translate(-90.896 -216.592)",
    fill: "#00acb1"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset9);
export default __webpack_public_path__ + "static/media/asset-9.42c55a198fd81788bb88b82ae4568717.svg";
export { ForwardRef as ReactComponent };